<template>
	<div class="GoogleAppsOverlay">
		<div :class="googleClassName">
			<h4 v-if="type === 'maps'">
				<map-marker-icon :size="35" class="OptOutIcon" />Google Maps
			</h4>
			<h4 v-if="type === 'videos'">
				YouTube
				<youtube-icon :size="35" class="OptOutIcon" />
			</h4>
			<div>
				{{ description }}
			</div>
			<div class="text-center">
				(<a href="https://policies.google.com/privacy" target="_blank"
					>https://policies.google.com/privacy</a
				>).
			</div>
			<div>
				{{ $t('consentContent.revokeText') }}
			</div>
			<div v-on:click="$emit('onAllowApp')" class="OptOutButton mt-4">
				{{ $t('consentContent.permitText') }}
			</div>
		</div>
	</div>
</template>

<script>
import MapMarkerIcon from 'vue-material-design-icons/MapMarker.vue'
import YoutubeIcon from 'vue-material-design-icons/Youtube.vue'

export default {
	name: 'GoogleAppsOverlay',
	components: {
		MapMarkerIcon,
		YoutubeIcon
	},
	props: {
		description: String,
		type: String
	},
	computed: {
		matchScreenSize() {
			return window.screen.availWidth >= 568
		},
		googleClassName() {
			if (this.matchScreenSize) {
				return 'GoogleAppsOverlay__OptInRequest'
			} else {
				return 'GoogleAppsOverlay__OptInRequest--small'
			}
		}
	},
	i18n: {
		messages: {
			de: require('@/i18n/de/de_consent.json'),
			en: require('@/i18n/en/eng_consent.json')
		}
	}
}
</script>

<style scoped lang="stylus">
.GoogleAppsOverlay__OptInRequest {
	width: 500px;
	height: 450px;
	background-color: rgba(11,38,46,0.9);
	padding: 4rem 3rem;
	border: 1px rgba(255,255,255,0.6) solid;
	transition: transform .2s;
}
.GoogleAppsOverlay__OptInRequest--small {
	width: 310px;
	height: 480px;
	background-color: rgba(11,38,46,0.9);
	padding: 4rem 3rem;
	border: 1px rgba(255,255,255,0.6) solid;
	transition: transform .2s;
}
.GoogleAppsOverlay__OptInRequest:hover {
	transform: scale(1.04);
    background-color: rgba(11,38,46,0.8);
}
h4 {
	display: flex;
	align-items: center;
}
.OptOutIcon {
	margin-right: 0.6rem;
}
.OptOutButton {
	float: right;
	border: rgba(255,255,255,0.6) 1px solid;
	padding: 10px;
	text-transform: uppercase;
	transition: transform .2s;
	cursor: pointer;
}
a {
	color: red;
}
</style>
